<div *ngIf="isLoading$ | async" class="global-loading-overlay">
  <mat-spinner [diameter]="50"></mat-spinner>
  <p>Loading...</p>
</div>

<router-outlet></router-outlet>